export interface NCAASchool {
  name: string;
  espnId?: number;
  division: "D1" | "D2";
}

export function getSchoolLogoUrl(espnId: number): string {
  return `https://a.espncdn.com/i/teamlogos/ncaa/500/${espnId}.png`;
}

export const NCAA_SCHOOLS: NCAASchool[] = [
  // ACC
  { name: "Boston College", espnId: 103, division: "D1" },
  { name: "Clemson", espnId: 228, division: "D1" },
  { name: "Duke", espnId: 150, division: "D1" },
  { name: "Florida State", espnId: 52, division: "D1" },
  { name: "Georgia Tech", espnId: 59, division: "D1" },
  { name: "Louisville", espnId: 97, division: "D1" },
  { name: "Miami (FL)", espnId: 2390, division: "D1" },
  { name: "North Carolina", espnId: 153, division: "D1" },
  { name: "NC State", espnId: 152, division: "D1" },
  { name: "Notre Dame", espnId: 87, division: "D1" },
  { name: "Pittsburgh", espnId: 221, division: "D1" },
  { name: "Syracuse", espnId: 183, division: "D1" },
  { name: "Virginia", espnId: 258, division: "D1" },
  { name: "Virginia Tech", espnId: 259, division: "D1" },
  { name: "Wake Forest", espnId: 154, division: "D1" },
  // SEC
  { name: "Alabama", espnId: 333, division: "D1" },
  { name: "Arkansas", espnId: 8, division: "D1" },
  { name: "Auburn", espnId: 2, division: "D1" },
  { name: "Florida", espnId: 57, division: "D1" },
  { name: "Georgia", espnId: 61, division: "D1" },
  { name: "Kentucky", espnId: 96, division: "D1" },
  { name: "LSU", espnId: 99, division: "D1" },
  { name: "Mississippi State", espnId: 344, division: "D1" },
  { name: "Missouri", espnId: 142, division: "D1" },
  { name: "Ole Miss", espnId: 145, division: "D1" },
  { name: "Oklahoma", espnId: 201, division: "D1" },
  { name: "South Carolina", espnId: 2579, division: "D1" },
  { name: "Tennessee", espnId: 2633, division: "D1" },
  { name: "Texas", espnId: 251, division: "D1" },
  { name: "Texas A&M", espnId: 245, division: "D1" },
  { name: "Vanderbilt", espnId: 238, division: "D1" },
  // Big Ten
  { name: "Illinois", espnId: 356, division: "D1" },
  { name: "Indiana", espnId: 84, division: "D1" },
  { name: "Iowa", espnId: 2294, division: "D1" },
  { name: "Maryland", espnId: 120, division: "D1" },
  { name: "Michigan", espnId: 130, division: "D1" },
  { name: "Michigan State", espnId: 127, division: "D1" },
  { name: "Minnesota", espnId: 135, division: "D1" },
  { name: "Nebraska", espnId: 158, division: "D1" },
  { name: "Northwestern", espnId: 77, division: "D1" },
  { name: "Ohio State", espnId: 194, division: "D1" },
  { name: "Oregon", espnId: 2483, division: "D1" },
  { name: "Penn State", espnId: 213, division: "D1" },
  { name: "Purdue", espnId: 2528, division: "D1" },
  { name: "Rutgers", espnId: 164, division: "D1" },
  { name: "UCLA", espnId: 26, division: "D1" },
  { name: "USC", espnId: 30, division: "D1" },
  { name: "Washington", espnId: 264, division: "D1" },
  { name: "Wisconsin", espnId: 275, division: "D1" },
  // Big 12
  { name: "Arizona", espnId: 12, division: "D1" },
  { name: "Arizona State", espnId: 9, division: "D1" },
  { name: "Baylor", espnId: 239, division: "D1" },
  { name: "BYU", espnId: 252, division: "D1" },
  { name: "Cincinnati", espnId: 2132, division: "D1" },
  { name: "Colorado", espnId: 38, division: "D1" },
  { name: "Houston", espnId: 248, division: "D1" },
  { name: "Iowa State", espnId: 66, division: "D1" },
  { name: "Kansas", espnId: 2305, division: "D1" },
  { name: "Kansas State", espnId: 2306, division: "D1" },
  { name: "Oklahoma State", espnId: 197, division: "D1" },
  { name: "TCU", espnId: 2628, division: "D1" },
  { name: "Texas Tech", espnId: 2641, division: "D1" },
  { name: "UCF", espnId: 2116, division: "D1" },
  { name: "Utah", espnId: 254, division: "D1" },
  { name: "West Virginia", espnId: 277, division: "D1" },
  // Pac-12 holdovers
  { name: "California", espnId: 25, division: "D1" },
  { name: "Oregon State", espnId: 204, division: "D1" },
  { name: "Stanford", espnId: 24, division: "D1" },
  { name: "Washington State", espnId: 265, division: "D1" },
  // Mountain West
  { name: "Air Force", espnId: 2005, division: "D1" },
  { name: "Boise State", espnId: 68, division: "D1" },
  { name: "Colorado State", espnId: 36, division: "D1" },
  { name: "Fresno State", espnId: 278, division: "D1" },
  { name: "Hawaii", espnId: 62, division: "D1" },
  { name: "Nevada", espnId: 2440, division: "D1" },
  { name: "New Mexico", espnId: 167, division: "D1" },
  { name: "San Diego State", espnId: 21, division: "D1" },
  { name: "UNLV", espnId: 2439, division: "D1" },
  { name: "Utah State", espnId: 328, division: "D1" },
  { name: "Wyoming", espnId: 2751, division: "D1" },
  // American Athletic
  { name: "Army", espnId: 349, division: "D1" },
  { name: "Charlotte", espnId: 2429, division: "D1" },
  { name: "East Carolina", espnId: 151, division: "D1" },
  { name: "Memphis", espnId: 235, division: "D1" },
  { name: "Navy", espnId: 2426, division: "D1" },
  { name: "North Texas", espnId: 249, division: "D1" },
  { name: "Rice", espnId: 242, division: "D1" },
  { name: "SMU", espnId: 2567, division: "D1" },
  { name: "South Florida", espnId: 58, division: "D1" },
  { name: "Temple", espnId: 218, division: "D1" },
  { name: "Tulane", espnId: 2655, division: "D1" },
  { name: "Tulsa", espnId: 202, division: "D1" },
  { name: "UTSA", espnId: 2636, division: "D1" },
  // Big East
  { name: "Butler", espnId: 2086, division: "D1" },
  { name: "Creighton", espnId: 156, division: "D1" },
  { name: "DePaul", espnId: 305, division: "D1" },
  { name: "Georgetown", espnId: 46, division: "D1" },
  { name: "Marquette", espnId: 269, division: "D1" },
  { name: "Providence", espnId: 2507, division: "D1" },
  { name: "Seton Hall", espnId: 2550, division: "D1" },
  { name: "St. John's", espnId: 2569, division: "D1" },
  { name: "UConn", espnId: 41, division: "D1" },
  { name: "Villanova", espnId: 2762, division: "D1" },
  { name: "Xavier", espnId: 2752, division: "D1" },
  // WCC
  { name: "Gonzaga", espnId: 2250, division: "D1" },
  { name: "Pacific", espnId: 279, division: "D1" },
  { name: "Pepperdine", espnId: 2490, division: "D1" },
  { name: "Portland", espnId: 2501, division: "D1" },
  { name: "Saint Mary's", espnId: 2608, division: "D1" },
  { name: "San Diego", espnId: 301, division: "D1" },
  { name: "San Francisco", espnId: 2620, division: "D1" },
  { name: "Santa Clara", espnId: 2617, division: "D1" },
  // Atlantic 10
  { name: "Dayton", espnId: 2826, division: "D1" },
  { name: "Davidson", espnId: 2168, division: "D1" },
  { name: "Fordham", espnId: 2210, division: "D1" },
  { name: "George Mason", espnId: 2235, division: "D1" },
  { name: "George Washington", espnId: 45, division: "D1" },
  { name: "Massachusetts", espnId: 113, division: "D1" },
  { name: "Rhode Island", espnId: 227, division: "D1" },
  { name: "Richmond", espnId: 257, division: "D1" },
  { name: "Saint Louis", espnId: 139, division: "D1" },
  { name: "St. Bonaventure", espnId: 179, division: "D1" },
  { name: "VCU", espnId: 2670, division: "D1" },
  // Sun Belt
  { name: "Appalachian State", espnId: 2026, division: "D1" },
  { name: "Arkansas State", espnId: 2032, division: "D1" },
  { name: "Georgia Southern", espnId: 290, division: "D1" },
  { name: "Georgia State", espnId: 2247, division: "D1" },
  { name: "James Madison", espnId: 256, division: "D1" },
  { name: "Louisiana", espnId: 309, division: "D1" },
  { name: "Louisiana Monroe", espnId: 2433, division: "D1" },
  { name: "Marshall", espnId: 276, division: "D1" },
  { name: "Old Dominion", espnId: 295, division: "D1" },
  { name: "South Alabama", espnId: 6, division: "D1" },
  { name: "Southern Miss", espnId: 2572, division: "D1" },
  { name: "Texas State", espnId: 326, division: "D1" },
  { name: "Troy", espnId: 2653, division: "D1" },
  // Conference USA
  { name: "Florida Atlantic", espnId: 2226, division: "D1" },
  { name: "FIU", espnId: 2229, division: "D1" },
  { name: "Jacksonville State", espnId: 2599, division: "D1" },
  { name: "Liberty", espnId: 2335, division: "D1" },
  { name: "Middle Tennessee", espnId: 2393, division: "D1" },
  { name: "New Mexico State", espnId: 166, division: "D1" },
  { name: "Sam Houston", division: "D1" },
  { name: "UAB", espnId: 2330, division: "D1" },
  { name: "Western Kentucky", espnId: 98, division: "D1" },
  // MAC
  { name: "Akron", espnId: 2006, division: "D1" },
  { name: "Ball State", espnId: 2050, division: "D1" },
  { name: "Bowling Green", espnId: 189, division: "D1" },
  { name: "Buffalo", espnId: 2084, division: "D1" },
  { name: "Central Michigan", espnId: 2117, division: "D1" },
  { name: "Eastern Michigan", espnId: 2199, division: "D1" },
  { name: "Kent State", espnId: 2309, division: "D1" },
  { name: "Miami (OH)", espnId: 193, division: "D1" },
  { name: "Northern Illinois", espnId: 2459, division: "D1" },
  { name: "Ohio", espnId: 195, division: "D1" },
  { name: "Toledo", espnId: 2649, division: "D1" },
  { name: "Western Michigan", espnId: 2711, division: "D1" },
  // Ivy League
  { name: "Brown", espnId: 225, division: "D1" },
  { name: "Columbia", espnId: 171, division: "D1" },
  { name: "Cornell", espnId: 172, division: "D1" },
  { name: "Dartmouth", espnId: 159, division: "D1" },
  { name: "Harvard", espnId: 108, division: "D1" },
  { name: "Penn", espnId: 219, division: "D1" },
  { name: "Princeton", espnId: 163, division: "D1" },
  { name: "Yale", espnId: 43, division: "D1" },
  // Missouri Valley
  { name: "Bradley", espnId: 71, division: "D1" },
  { name: "Drake", espnId: 2181, division: "D1" },
  { name: "Evansville", espnId: 339, division: "D1" },
  { name: "Illinois State", espnId: 318, division: "D1" },
  { name: "Indiana State", espnId: 85, division: "D1" },
  { name: "Loyola Chicago", espnId: 2714, division: "D1" },
  { name: "Missouri State", espnId: 2623, division: "D1" },
  { name: "Northern Iowa", espnId: 2534, division: "D1" },
  { name: "Southern Illinois", espnId: 79, division: "D1" },
  { name: "Valparaiso", espnId: 2674, division: "D1" },
  // Ohio Valley
  { name: "Austin Peay", espnId: 2036, division: "D1" },
  { name: "Belmont", espnId: 2057, division: "D1" },
  { name: "Eastern Illinois", espnId: 2197, division: "D1" },
  { name: "Eastern Kentucky", espnId: 2198, division: "D1" },
  { name: "Morehead State", espnId: 2404, division: "D1" },
  { name: "Murray State", espnId: 2413, division: "D1" },
  { name: "SE Missouri State", espnId: 2546, division: "D1" },
  { name: "SIU Edwardsville", espnId: 2561, division: "D1" },
  { name: "Tennessee State", espnId: 2634, division: "D1" },
  { name: "Tennessee Tech", espnId: 2635, division: "D1" },
  { name: "UT Martin", espnId: 2630, division: "D1" },
  // Southern Conference
  { name: "The Citadel", espnId: 2166, division: "D1" },
  { name: "Chattanooga", espnId: 236, division: "D1" },
  { name: "East Tennessee State", espnId: 2193, division: "D1" },
  { name: "Furman", espnId: 231, division: "D1" },
  { name: "Mercer", espnId: 2382, division: "D1" },
  { name: "Samford", espnId: 2582, division: "D1" },
  { name: "UNCG", espnId: 2296, division: "D1" },
  { name: "VMI", division: "D1" },
  { name: "Western Carolina", espnId: 2713, division: "D1" },
  { name: "Wofford", espnId: 2749, division: "D1" },
  // Patriot League
  { name: "American", espnId: 44, division: "D1" },
  { name: "Boston University", espnId: 104, division: "D1" },
  { name: "Bucknell", espnId: 2083, division: "D1" },
  { name: "Colgate", espnId: 37, division: "D1" },
  { name: "Holy Cross", espnId: 107, division: "D1" },
  { name: "Lafayette", division: "D1" },
  { name: "Lehigh", espnId: 322, division: "D1" },
  { name: "Loyola Maryland", espnId: 2350, division: "D1" },
  // MAAC
  { name: "Canisius", espnId: 2097, division: "D1" },
  { name: "Fairfield", espnId: 2221, division: "D1" },
  { name: "Iona", espnId: 314, division: "D1" },
  { name: "Manhattan", espnId: 114, division: "D1" },
  { name: "Marist", espnId: 2368, division: "D1" },
  { name: "Niagara", espnId: 2449, division: "D1" },
  { name: "Quinnipiac", espnId: 2520, division: "D1" },
  { name: "Rider", espnId: 2529, division: "D1" },
  { name: "Saint Peter's", espnId: 2578, division: "D1" },
  { name: "Siena", division: "D1" },
  // CAA (Coastal Athletic Association)
  { name: "Delaware", espnId: 48, division: "D1" },
  { name: "Drexel", espnId: 2185, division: "D1" },
  { name: "Elon", division: "D1" },
  { name: "Hofstra", espnId: 2275, division: "D1" },
  { name: "Monmouth", espnId: 2405, division: "D1" },
  { name: "Northeastern", espnId: 111, division: "D1" },
  { name: "Stony Brook", espnId: 2571, division: "D1" },
  { name: "Towson", division: "D1" },
  { name: "UNC Wilmington", espnId: 350, division: "D1" },
  { name: "William & Mary", espnId: 2729, division: "D1" },
  // America East
  { name: "Albany", espnId: 399, division: "D1" },
  { name: "Binghamton", espnId: 2066, division: "D1" },
  { name: "Maine", espnId: 311, division: "D1" },
  { name: "New Hampshire", espnId: 160, division: "D1" },
  { name: "UMBC", espnId: 2378, division: "D1" },
  { name: "Vermont", espnId: 261, division: "D1" },
  // ASUN
  { name: "Bellarmine", division: "D1" },
  { name: "Central Arkansas", espnId: 2110, division: "D1" },
  { name: "Florida Gulf Coast", espnId: 526, division: "D1" },
  { name: "Jacksonville", espnId: 294, division: "D1" },
  { name: "Kennesaw State", espnId: 338, division: "D1" },
  { name: "Lipscomb", espnId: 2348, division: "D1" },
  { name: "North Alabama", division: "D1" },
  { name: "North Florida", division: "D1" },
  { name: "Northern Kentucky", espnId: 2545, division: "D1" },
  { name: "Queens (NC)", division: "D1" },
  { name: "USC Upstate", espnId: 2590, division: "D1" },
  // Big South
  { name: "Campbell", espnId: 2099, division: "D1" },
  { name: "Charleston Southern", espnId: 2127, division: "D1" },
  { name: "Gardner-Webb", espnId: 2241, division: "D1" },
  { name: "Hampton", espnId: 2261, division: "D1" },
  { name: "High Point", espnId: 2272, division: "D1" },
  { name: "Longwood", espnId: 2352, division: "D1" },
  { name: "Presbyterian", division: "D1" },
  { name: "Radford", espnId: 2521, division: "D1" },
  { name: "Robert Morris", espnId: 2539, division: "D1" },
  { name: "Winthrop", espnId: 2737, division: "D1" },
  // WAC
  { name: "Abilene Christian", espnId: 2000, division: "D1" },
  { name: "California Baptist", division: "D1" },
  { name: "Grand Canyon", espnId: 2253, division: "D1" },
  { name: "Southern Utah", espnId: 2573, division: "D1" },
  { name: "Tarleton State", division: "D1" },
  { name: "UT Rio Grande Valley", espnId: 2638, division: "D1" },
  { name: "Utah Tech", division: "D1" },
  // Big West
  { name: "Cal Poly", espnId: 13, division: "D1" },
  { name: "Cal State Bakersfield", espnId: 2325, division: "D1" },
  { name: "Cal State Fullerton", espnId: 2239, division: "D1" },
  { name: "Cal State Northridge", espnId: 2463, division: "D1" },
  { name: "Long Beach State", espnId: 323, division: "D1" },
  { name: "UC Davis", espnId: 2523, division: "D1" },
  { name: "UC Irvine", espnId: 2585, division: "D1" },
  { name: "UC Riverside", espnId: 2587, division: "D1" },
  { name: "UC San Diego", espnId: 2510, division: "D1" },
  { name: "UC Santa Barbara", espnId: 2592, division: "D1" },
  // NEC (Northeast Conference)
  { name: "Bryant", division: "D1" },
  { name: "Central Connecticut", espnId: 2115, division: "D1" },
  { name: "Fairleigh Dickinson", espnId: 2214, division: "D1" },
  { name: "LIU", espnId: 2345, division: "D1" },
  { name: "Merrimack", division: "D1" },
  { name: "Sacred Heart", espnId: 2541, division: "D1" },
  { name: "Saint Francis (PA)", espnId: 2556, division: "D1" },
  { name: "Wagner", espnId: 2681, division: "D1" },
  // SWAC
  { name: "Alabama A&M", espnId: 2010, division: "D1" },
  { name: "Alabama State", espnId: 2011, division: "D1" },
  { name: "Alcorn State", espnId: 2016, division: "D1" },
  { name: "Arkansas-Pine Bluff", espnId: 2029, division: "D1" },
  { name: "Bethune-Cookman", espnId: 2065, division: "D1" },
  { name: "Florida A&M", espnId: 50, division: "D1" },
  { name: "Grambling", espnId: 2755, division: "D1" },
  { name: "Jackson State", espnId: 2396, division: "D1" },
  { name: "Mississippi Valley State", espnId: 2400, division: "D1" },
  { name: "Prairie View A&M", division: "D1" },
  { name: "Southern", espnId: 2570, division: "D1" },
  { name: "Texas Southern", espnId: 2640, division: "D1" },
  // MEAC
  { name: "Coppin State", espnId: 2142, division: "D1" },
  { name: "Delaware State", espnId: 2169, division: "D1" },
  { name: "Howard", espnId: 47, division: "D1" },
  { name: "Maryland-Eastern Shore", espnId: 2379, division: "D1" },
  { name: "Morgan State", espnId: 2406, division: "D1" },
  { name: "Norfolk State", espnId: 2455, division: "D1" },
  { name: "North Carolina A&T", espnId: 2448, division: "D1" },
  { name: "North Carolina Central", espnId: 2450, division: "D1" },
  { name: "South Carolina State", division: "D1" },
  // Horizon League
  { name: "Cleveland State", espnId: 325, division: "D1" },
  { name: "Detroit Mercy", espnId: 2174, division: "D1" },
  { name: "Green Bay", division: "D1" },
  { name: "Milwaukee", espnId: 270, division: "D1" },
  { name: "Oakland", espnId: 2466, division: "D1" },
  { name: "Purdue Fort Wayne", espnId: 2870, division: "D1" },
  { name: "Wright State", espnId: 2750, division: "D1" },
  { name: "Youngstown State", espnId: 2754, division: "D1" },
  // Southland
  { name: "Houston Christian", division: "D1" },
  { name: "Incarnate Word", espnId: 2903, division: "D1" },
  { name: "Lamar", espnId: 321, division: "D1" },
  { name: "McNeese State", espnId: 2377, division: "D1" },
  { name: "Nicholls State", espnId: 2447, division: "D1" },
  { name: "Northwestern State", espnId: 2461, division: "D1" },
  { name: "SE Louisiana", espnId: 2547, division: "D1" },
  { name: "Stephen F. Austin", espnId: 2596, division: "D1" },
  { name: "Texas A&M-Corpus Christi", division: "D1" },
  // Summit League
  { name: "Denver", espnId: 2172, division: "D1" },
  { name: "Kansas City", espnId: 140, division: "D1" },
  { name: "Omaha", espnId: 2437, division: "D1" },
  { name: "Oral Roberts", espnId: 198, division: "D1" },
  { name: "South Dakota", espnId: 233, division: "D1" },
  { name: "South Dakota State", division: "D1" },
  { name: "Western Illinois", espnId: 2710, division: "D1" },
  // Big Sky
  { name: "Eastern Washington", espnId: 331, division: "D1" },
  { name: "Idaho", espnId: 70, division: "D1" },
  { name: "Idaho State", espnId: 304, division: "D1" },
  { name: "Montana", espnId: 149, division: "D1" },
  { name: "Montana State", espnId: 147, division: "D1" },
  { name: "Northern Arizona", espnId: 2464, division: "D1" },
  { name: "Northern Colorado", espnId: 2458, division: "D1" },
  { name: "Portland State", espnId: 2498, division: "D1" },
  { name: "Sacramento State", espnId: 16, division: "D1" },
  { name: "Weber State", espnId: 2692, division: "D1" },
  // Independent DI
  { name: "New Jersey Institute of Technology", division: "D1" },
  // -------------------------------------------------------
  // Division II
  // -------------------------------------------------------
  { name: "Adelphi", division: "D2" },
  { name: "Angelo State", division: "D2" },
  { name: "Assumption", division: "D2" },
  { name: "Barry", division: "D2" },
  { name: "Bloomsburg", division: "D2" },
  { name: "Chico State", division: "D2" },
  { name: "Colorado Mesa", division: "D2" },
  { name: "Colorado School of Mines", division: "D2" },
  { name: "Delta State", division: "D2" },
  { name: "Drury", division: "D2" },
  { name: "East Stroudsburg", division: "D2" },
  { name: "Edinboro", division: "D2" },
  { name: "Emporia State", division: "D2" },
  { name: "Florida Southern", division: "D2" },
  { name: "Fort Hays State", division: "D2" },
  { name: "Grand Valley State", division: "D2" },
  { name: "Henderson State", division: "D2" },
  { name: "Humboldt State", division: "D2" },
  { name: "Indiana (PA)", division: "D2" },
  { name: "Kutztown", division: "D2" },
  { name: "Lake Erie", division: "D2" },
  { name: "Lenoir-Rhyne", division: "D2" },
  { name: "Limestone", division: "D2" },
  { name: "Lincoln Memorial", division: "D2" },
  { name: "Lees-McRae", division: "D2" },
  { name: "Mars Hill", division: "D2" },
  { name: "Mercyhurst", division: "D2" },
  { name: "Minnesota Duluth", division: "D2" },
  { name: "Minot State", division: "D2" },
  { name: "Missouri Western", division: "D2" },
  { name: "Northwest Missouri State", division: "D2" },
  { name: "Nova Southeastern", division: "D2" },
  { name: "Ouachita Baptist", division: "D2" },
  { name: "Pittsburg State", division: "D2" },
  { name: "Rollins", division: "D2" },
  { name: "Saint Anselm", division: "D2" },
  { name: "Shippensburg", division: "D2" },
  { name: "Slippery Rock", division: "D2" },
  { name: "Tampa", division: "D2" },
  { name: "Texas A&M Commerce", division: "D2" },
  { name: "Texas A&M Kingsville", division: "D2" },
  { name: "Tiffin", division: "D2" },
  { name: "Truman State", division: "D2" },
  { name: "Washburn", division: "D2" },
  { name: "West Chester", division: "D2" },
  { name: "West Florida", division: "D2" },
  { name: "West Texas A&M", division: "D2" },
  { name: "Western Colorado", division: "D2" },
  { name: "Wingate", division: "D2" },
  { name: "Winston-Salem State", division: "D2" },
];
